import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Geneva United Methodist Church';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_geneva-faith-site/artifacts/ffjjquf2_Church-outside-overview-photo.png';
const SITE_URL = 'https://genevaumc.com';

export const SEO = ({ 
  title, 
  description, 
  image,
  url,
  type = 'website',
  noIndex = false 
}) => {
  // Build the full title
  const fullTitle = title 
    ? `${title} | ${SITE_NAME}` 
    : SITE_NAME;

  // Default description
  const metaDescription = description || 
    'Welcome to Geneva United Methodist Church in Geneva, Ohio. Join us for worship, fellowship, and community.';

  // Get canonical URL - always use https://genevaumc.com (no www)
  const getCanonicalUrl = () => {
    if (url) {
      // If URL provided, ensure it uses the canonical domain
      return url.startsWith('/') ? `${SITE_URL}${url}` : url;
    }
    if (typeof window !== 'undefined') {
      // Get path from current URL and build canonical
      const path = window.location.pathname + window.location.search;
      return `${SITE_URL}${path}`;
    }
    return SITE_URL;
  };
  
  const canonicalUrl = getCanonicalUrl();

  // Social image - use provided or default
  const socialImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      {socialImage && <meta property="og:image" content={socialImage} />}
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {socialImage && <meta name="twitter:image" content={socialImage} />}

      {/* Canonical URL - Always points to https://genevaumc.com */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
